import { useFirebaseConfig } from "./remote-config";

type ReigniteApiUsageConfig = {
  [key: number]: {
    blacklist: number[]
    whitelist: number[]
  }
}

type MobileAppPromoConfig = {
  whitelistIds: number[]
}

export default function useReigniteMetadata() {
  const firebaseConfig = useFirebaseConfig()

  return {
    isFetchingFirebaseConfig: !firebaseConfig.initialized,
    isReigniteMetadataAvailable: firebaseConfig.config.useReigniteMetadata?.asBoolean() ?? false,
    mobileAppPromoConfig: firebaseConfig.config.mobileAppPromoConfig
      ? JSON.parse(firebaseConfig.config.mobileAppPromoConfig.asString()) as MobileAppPromoConfig
      : null,
    reigniteApiUsageConfig: firebaseConfig.config.useReigniteApi
      ? JSON.parse(firebaseConfig.config.useReigniteApi.asString()) as ReigniteApiUsageConfig
      : null
  }
}

export type { ReigniteApiUsageConfig }